/**
 * M.AI.RY WISDOM BOT SSO UTILITY
 * Secure SSO integration for m.ai.ry wisdom bot
 */

const MAIRY_BASE_URL = 'https://mairy.io';
const SSO_SHARED_SECRET = process.env.REACT_APP_SSO_SECRET_MAIRY || 'belonging_sessions_mairy_secret_2024';

/**
 * Generate SSO link for m.ai.ry Wisdom Bot
 * @param {Object} user - User object with id, name, email
 * @param {Object} context - Optional context (current question, topic, etc.)
 * @returns {Promise<string>} - SSO URL to redirect user to
 */
export async function generateMairyWisdomLink(user, context = {}) {
  // Prepare user data
  const userData = {
    id: user.id || user._id || "unknown",
    name: user.name || `${user.first_name} ${user.last_name}` || "Seeker",
    email: user.email || "",
    roles: user.roles || ["user"],
    context: context
  };
  
  // Encode user data as base64
  const bs_user = btoa(JSON.stringify(userData));
  
  // Create timestamp
  const bs_time = Date.now().toString();
  
  // Generate verification token
  const bs_token = await generateSSOToken(bs_user, bs_time);
  
  // Build and return URL
  return `${MAIRY_BASE_URL}/wisdom?bs_user=${encodeURIComponent(bs_user)}&bs_token=${bs_token}&bs_time=${bs_time}`;
}

/**
 * Generate SHA-256 verification token
 */
async function generateSSOToken(userData, timestamp) {
  const data = `${userData}:${timestamp}:${SSO_SHARED_SECRET}`;
  
  const encoder = new TextEncoder();
  const dataBuffer = encoder.encode(data);
  const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  
  return hashHex.substring(0, 32);
}
